import React from "react";
// Named imports, never `import * as`: the namespace form defeats tree-shaking and
// pulled all of lucide-react (611 KiB) into the bundle to support a lookup by
// arbitrary string. The admin picker is a closed dropdown of eight brands, all of
// which are drawn by the hand-written SVGs below, so the only job left for lucide
// here is covering legacy `icon_name` values and an unknown-value fallback.
import { Ghost, HelpCircle, Mail, Send, ShoppingBag, Video } from "lucide-react";

const LUCIDE_FALLBACKS: Record<string, React.ComponentType<any>> = {
  ghost: Ghost,
  mail: Mail,
  send: Send,
  shoppingbag: ShoppingBag,
  video: Video,
};

export function TikTokIcon({
  className = "w-5 h-5",
  style,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} {...props}>
      <path d="M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-5.201 1.743 2.895 2.895 0 0 1 2.314-4.643c.287 0 .568.044.838.125V9.362a6.31 6.31 0 0 0-1-.077 6.262 6.262 0 1 0 6.262 6.263V9.049a8.27 8.27 0 0 0 5.08 1.727V7.319a4.846 4.846 0 0 1-1.078-.633z" />
    </svg>
  );
}

export function DiscordIcon({
  className = "w-5 h-5",
  style,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} {...props}>
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994.021-.041.001-.09-.041-.106a13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.061 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.893.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.028zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
    </svg>
  );
}

export function InstagramIcon({
  className = "w-5 h-5",
  style,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} {...props}>
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4.162 4.162 0 1 1 0-8.324 4.162 4.162 0 0 1 0 8.324zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
    </svg>
  );
}

export function FacebookIcon({
  className = "w-5 h-5",
  style,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} {...props}>
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
  );
}

export function TwitterIcon({
  className = "w-5 h-5",
  style,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} {...props}>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export function YoutubeIcon({
  className = "w-5 h-5",
  style,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} {...props}>
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  );
}

export function TelegramIcon({
  className = "w-5 h-5",
  style,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} {...props}>
      <path d="M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm5.562 8.161c-.18.717-.962 4.084-1.362 5.753-.169.706-.43 1.054-.68 1.077-.546.05-1.042-.36-1.57-.706-.827-.542-1.294-.878-2.095-1.406-.926-.61-.326-.944.202-1.492.138-.143 2.535-2.324 2.581-2.52.006-.025.01-.12-.046-.17-.056-.05-.138-.033-.198-.02-.085.019-1.438.915-4.06 2.686-.384.263-.732.393-1.044.385-.344-.008-.997-.195-1.488-.354-.602-.195-1.08-.299-1.038-.631.022-.173.26-.35.714-.53 2.798-1.218 4.664-2.023 5.598-2.412 2.668-1.11 3.224-1.303 3.584-1.309.079-.001.257.019.373.113.098.08.125.188.136.264.01.077.025.26-.002.435z" />
    </svg>
  );
}

export function GmailIcon({
  className = "w-5 h-5",
  style,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} {...props}>
      <path d="M24 5.457v13.086c0 .729-.6 1.328-1.339 1.328h-3.455V10.68L12 16.48 4.794 10.68v9.191H1.339A1.333 1.333 0 0 1 0 18.543V5.457c0-1.034 1.168-1.637 2.016-1.044l9.984 7.49 9.984-7.49c.848-.593 2.016.01 2.016 1.044z" />
    </svg>
  );
}

export function getAccountIconComponent(iconName: string): React.ComponentType<any> {
  const nameLower = (iconName || "").toLowerCase();
  if (nameLower === "tiktok" || nameLower === "video") return TikTokIcon;
  if (nameLower === "discord" || nameLower === "ghost") return DiscordIcon;
  if (nameLower === "instagram") return InstagramIcon;
  if (nameLower === "facebook") return FacebookIcon;
  if (nameLower === "twitter" || nameLower === "x") return TwitterIcon;
  if (nameLower === "youtube") return YoutubeIcon;
  if (nameLower === "telegram" || nameLower === "send") return TelegramIcon;
  if (nameLower === "gmail" || nameLower === "mail") return GmailIcon;

  return LUCIDE_FALLBACKS[nameLower] ?? HelpCircle;
}

export function SocialIcon({
  name,
  className = "w-5 h-5",
  color,
  style,
  ...props
}: {
  name: string;
  className?: string;
  color?: string;
  style?: React.CSSProperties;
  [key: string]: any;
}) {
  const IconComponent = getAccountIconComponent(name);
  return <IconComponent className={className} style={{ color, ...style }} {...props} />;
}
